import React, { Fragment, useEffect, useState } from "react";
import authQueries from '../../../queries/authQueries';
import { Link, useNavigate } from "react-router-dom";
import { usePaginationStore, userStore } from "../../../store/userStore";
import { Empty, message as messages, Popconfirm } from 'antd';
import { Text, Collapse, Grid, Switch, Avatar } from '@nextui-org/react';
import { decode } from 'html-entities';
import AddButton from '../../Common/AddButton';
import { Pagination, PaginationItem } from "@mui/material";
import PaginationComponent from "../../Common/PaginationComponent";


const ListCounselorAssociates =()=>{

    const [result, setResult] = useState([])
    const [name, setName] = useState('')
    const [pageSize, setPageSize] = useState(25)
    const [counselor, setCounselor] = useState("")
    const [counsSwitch, setCounsSwitch] = useState(false)
    const [office, setOffice] = useState(null)

    const currentPage = usePaginationStore((state) => state.currentPage);
    const setCurrentPage = usePaginationStore((state) => state.setCurrentPage);
  
    useEffect(()=>{
        refferalList.mutateAsync({search: name, page:currentPage, size:25, user: counsSwitch});
    },[name, counsSwitch, currentPage]);

    useEffect(()=> {
        officeList.mutateAsync({size:2500, page:0})
    }, [])

    const refferalList = authQueries.useCounselorAssociatesMutation(
        (response) => {
            setResult(response)            
        }
    )

    const officeList = authQueries.useOfficeMutationList(
        (res)=>{
        }
    )
    
    const searchData = (e) => {
        setName(e.target.value)
    }


    const addNewCounselor = authQueries.useAddNewCounselorAssociatesMutation(
        (res) => {
            if(res?.response?.data === "user already exist!"){
                messages.error('Counselor already used!')
            }
            refferalList.mutateAsync({search: name, page: currentPage, size:25, user: counsSwitch});
        }
    )

    const deleteCounselor = authQueries.useDeleteCounselorAssociatesMutation(
        (res) => {
            refferalList.mutateAsync({search: name, page: currentPage, size:25, user: counsSwitch});
        }
    )

    const handleSubmit =(rid)=> {
        if(!counselor){
            messages.error("Please select counselor")
            return
        }
        addNewCounselor.mutateAsync({rid: rid, uid:counselor})
        setCounselor("")
    }

    const handleDelete = (uid, rid) => {
        deleteCounselor.mutateAsync({rid:rid, uid: uid})
    }

    const handleSwitch =(e)=> {
        setCounsSwitch(e.target.checked)
    }

    const counselorList = authQueries.useOfficeWiseCounselorListMutation(
        (res)=>{
        }
    )

    const handleOffice =(e)=>{
        setOffice(e.target.value)
        counselorList.mutateAsync({role:3, office: e.target.value})
    }

    return(
        <div>
            <div className="breadcrumb-and-otherbuttons">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Associates Counselors</li>
                    </ol>
                </nav>
            </div>
            
            <div className="add_clients">
                <div className="row">
                    <div className="col-md-6 appointments-hing-wrpr">
                        <i className="appointments-icon">
                            <img src={require("../../../assets/images/appointments-today-icon.png")} width="" height="" alt="" />
                        </i>
                        <h2><span>&nbsp;</span>Associates Counselors</h2>
                    </div>
                    <div className="col-md-12">
                        <hr className="progress-hr" />
                    </div>
                </div>

                <div id="accordion" className="add_clients_accordion_form">
                    <div className="card" id="appointments_wrpr">
                        <div className="card-header">
                            Associates Counselors							
                        </div>
                        <div id="appointment_any" className="collapse show" data-parent="#accordion">
                            <div className="card-body">
                                <div className="row ">
                                    <div className="col-md-12">
                                        <div className="table-list-search-wrpr">
                                            <div className="row mb-3">
                                                <div className="col-md-12" style={{display:'flex', justifyContent:'space-between'}}>
                                                    <div style={{display:'flex', gap: 12, alignItems:'center', marginTop:'5px', fontSize:'12px'}}>
                                                        <Switch value={counsSwitch} onChange={handleSwitch} />
                                                        <span>Only show counselor-included offices</span>
                                                    </div>
                                                    <div style={{display:'flex', gap:'10px'}}>
                                                        <input style={{minWidth: '200px'}} onChange={searchData} className="form-control form-control-sm" type="text" placeholder="Search Office..." />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <Grid.Container style={{display:'block'}} gap={2}>
                                            <Grid>
                                                <Collapse.Group shadow>
                                                {
                                                    result?.data?.items?.map((item, index) =>{
                                                        let sl = 1
                                                        return(
                                                        <Collapse 
                                                            key={index} 
                                                            title={<Text h6>{item.refferal} - ({item?.userdetail?.user?.username})</Text>}
                                                            subtitle={<span style={{fontSize:'12px'}}>{item?.counselorAssociates?.length} Associates Counselors</span>}
                                                        >
                                                        <div className="mb-4">
                                                            <div style={{display:'flex', gap: "15px"}}>
                                                                <select onChange={handleOffice} style={{width: '230px'}} className="form-control form-control-sm">
                                                                    <option value="">Select Office</option>
                                                                    {
                                                                        officeList?.data?.data?.items?.map((it,ind) => {
                                                                            return(
                                                                                <option key={ind} value={it?.id}>{it?.name}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                                {office &&
                                                                <Fragment>
                                                                    <select value={counselor} onChange={(e)=> {setCounselor(e.target.value)}} style={{width: '230px'}} className="form-control form-control-sm">
                                                                        <option value="">Select Counselor</option>
                                                                        {
                                                                            counselorList?.data?.data?.map((it,ind) => {
                                                                                const exist = item?.counselorAssociates?.find(element => element.uid === it.id)
                                                                                if(exist){
                                                                                    return
                                                                                }
                                                                                return(
                                                                                    <option key={ind} value={it?.id}>{it?.userdetail.firstname} {it?.userdetail?.lastname}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                    <button
                                                                        onClick={()=> handleSubmit(item?.id)}
                                                                        style={{
                                                                        minHeight:'31px', 
                                                                        height:'31px', 
                                                                        border:'none', 
                                                                        background:'#323a51', 
                                                                        color:'#fff', 
                                                                        fontSize:'12px',
                                                                        paddingLeft:"10px",
                                                                        paddingRight:"10px",
                                                                        borderRadius: "5px"
                                                                    }}>Add New</button>
                                                                </Fragment>
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            item?.counselorAssociates?.length > 0 &&
                                                            <div className="table-wrpr">
                                                                <div className="table-section">
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <table className="table collageprogram">
                                                                                <thead>
                                                                                    <tr>
                                                                                    <th width="30">#</th>
                                                                                    <th width="60"></th>
                                                                                    <th>Name</th>
                                                                                    <th>Email</th>
                                                                                    <th>Mobile No</th>
                                                                                    <th width="100">&nbsp;</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody className="ui-sortable">
                                                                                {
                                                                                    item?.counselorAssociates?.map((items, indexes) => {
                                                                                        return(
                                                                                        <tr key={indexes} className="ui-sortable-handle">
                                                                                            <th className="">{sl++}</th>
                                                                                            <td>
                                                                                                <Avatar
                                                                                                size="md"
                                                                                                src={items?.user?.userdetail?.image ? `${process.env.REACT_APP_BASE_URL}/api/fileuploadcommon/${items?.user?.userdetail?.image}` : require('../../../assets/images/profile-avatar.jpg')}
                                                                                                bordered
                                                                                                />
                                                                                            </td>
                                                                                            <td>{decode(items?.user?.userdetail?.firstname)} {decode(items?.user?.userdetail?.lastname)}</td>
                                                                                            <td>{items.user?.userdetail?.email}</td>
                                                                                            <td>{items?.user?.userdetail?.phone}</td>
                                                                                            <td className="action-icons">
                                                                                                <Popconfirm
                                                                                                placement="left"
                                                                                                title="Are you sure to delete this counselor?"
                                                                                                onConfirm={(event) => {handleDelete(items?.user?.id, item?.id)}}
                                                                                                okText="Yes"
                                                                                                cancelText="No"
                                                                                                >
                                                                                                <button className="btn-removerow mb-0">Delete</button>
                                                                                                </Popconfirm>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )})
                                                                                }
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        }
                                                        {
                                                            item?.counselorAssociates?.length < 1 &&
                                                            <div className="mb-5">
                                                                <Empty description={<div className="font-poppins">No description found!</div>} />
                                                            </div>
                                                        }

                                                        </Collapse>
                                                    )})
                                                }
                                                </Collapse.Group>
                                                <PaginationComponent result={result} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                                            </Grid>
                                        </Grid.Container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListCounselorAssociates